import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const EditableTitle = ({ title, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(title || '');
  const inputRef = useRef(null);

  useEffect(() => {
    setEditValue(title || '');
  }, [title]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editValue.trim() && editValue !== title) {
      onUpdate(editValue.trim());
    } else {
      setEditValue(title || '');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      inputRef.current?.blur();
    }
    if (e.key === 'Escape') {
      setEditValue(title || '');
      setIsEditing(false);
    }
  };

  const handleChange = (e) => {
    setEditValue(e.target.value);
  };

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        className="editable-title-input"
        value={editValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
    );
  }

  return (
    <h1 className="editable-title" onClick={handleClick} title="Click to edit">
      {title || 'Untitled Conversation'}
    </h1>
  );
};

EditableTitle.propTypes = {
  title: PropTypes.string.isRequired,
  conversationId: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default EditableTitle;